import { AppPlatform } from './../types';
import { FeatureFlag } from '../types';
import { RecursiveStringifyEnums } from './buildDistro';

export const generateFeatureFlags: (platform: AppPlatform) => RecursiveStringifyEnums<FeatureFlag[]> = (_) => [
    {
        id: 'roll_out_test',
        name: 'Roll out test',
        createdAt: '2022-10-14T16:16:10.56777Z',
        updatedAt: '2022-11-01T10:00:00.491445Z',
        enabledAt: null,
        minimumVersion: '1.1.0',
        rolloutPercentage: 0.5,
        status: 'enabled',
        isNewlyEnabledInThisVersion: true,
        isNewlyDisabledInThisVersion: false,
        isSpecificallyTargetingThisVersion: false,
        isSpecificallyNotTargetingThisVersion: false,
        didChangeInThisVersion: false,
        shouldHighlight: true,
        highlightTooltipText: 'This flag was enabled after this release was created.',
        isStale: false,
        staleTooltipText: '',
        isEstimatedEnabledAt: false,
        isReadOnly: false,
        rules: [
            {
                id: 'cf57f7c1-9874-4403-b858-b80021ea181b',
                name: 'Roll out group',
                isDefault: false,
                audienceConditions: null,
                conditions: [
                    {
                        attribute: 'userId',
                        negate: false,
                        predicate: 'matches',
                        values: [
                            'd1b3b3b3-7b3e-4c9a-8622-7c1f19db0f8b',
                            '44aee7a1-d5d6-46dd-85a0-f76d86c072c0',
                            'd5aad47b-a4f5-41d2-ac00-ec1627aab439',
                        ],
                    },
                ],
                variations: [
                    {
                        key: '440c5e05-7bbe-4c9a-8622-7c1f19db0f8b',
                        name: 'On',
                        weight: 100,
                    },
                ],
            },
            {
                id: 'd78f171a-4cfe-4f42-810f-9699d4e16e47',
                name: 'Version > 1.0.0',
                isDefault: false,
                audienceConditions: null,
                conditions: [
                    {
                        attribute: 'appVersion',
                        negate: false,
                        predicate: 'greaterThan',
                        values: ['1.1.0'],
                    },
                ],
                variations: [
                    {
                        key: 'on',
                        name: 'On',
                        weight: 100,
                    },
                ],
            },
            {
                id: 'default',
                name: 'Default',
                isDefault: true,
                audienceConditions: null,
                conditions: null,
                variations: [
                    {
                        key: 'off',
                        name: 'Off',
                        weight: 100,
                    },
                ],
            },
        ],
        owner: null,
        variations: [
            {
                key: '2nd_rollout',
                name: '2nd rollout',
                rolloutPercentage: 0.3,
                variables: [
                    { type: 'double', key: 'target', value: '0.15' },
                    { type: 'string', key: 'user_type', value: 'demo' },
                ],
            },
            {
                key: 'on',
                name: 'On',
                rolloutPercentage: 0,
                variables: [{ type: 'double', key: 'target', value: '100' }],
            },
            {
                key: 'on',
                name: 'Off',
                rolloutPercentage: 0.7,
                variables: [{ type: 'double', key: 'target', value: '0' }],
            },
        ],
        url: '',
    },
    {
        id: 'new_product_page',
        name: 'New product page',
        createdAt: '2022-09-14T18:52:17.592443Z',
        updatedAt: '2022-10-30T18:55:27.996195Z',
        enabledAt: null,
        minimumVersion: '1.1.0',
        rolloutPercentage: 1,
        status: 'enabled',
        isNewlyEnabledInThisVersion: false,
        isNewlyDisabledInThisVersion: false,
        isSpecificallyTargetingThisVersion: false,
        isSpecificallyNotTargetingThisVersion: false,
        shouldHighlight: false,
        highlightTooltipText: '',
        isStale: false,
        staleTooltipText: '',
        didChangeInThisVersion: false,
        isEstimatedEnabledAt: false,
        isReadOnly: false,
        rules: [
            {
                id: 'cf57f7c1-9874-4403-b858-b80021ea181b',
                name: 'USA or Canada',
                isDefault: false,
                audienceConditions: null,
                conditions: [
                    {
                        attribute: 'country',
                        negate: false,
                        predicate: 'matches',
                        values: ['US', 'CA'],
                    },
                ],
                variations: [
                    {
                        key: 'on',
                        name: 'On',
                        weight: 100,
                    },
                ],
            },
            {
                id: 'd78f171a-4cfe-4f42-810f-9699d4e16e47',
                name: 'Version > 1.0.0',
                isDefault: false,
                audienceConditions: null,
                conditions: [
                    {
                        attribute: 'appVersion',
                        negate: false,
                        predicate: 'greaterThan',
                        values: ['1.1.0'],
                    },
                ],
                variations: [
                    {
                        key: 'on',
                        name: 'On',
                        weight: 100,
                    },
                ],
            },
        ],
        owner: null,
        variations: [
            { key: 'special', name: 'Special experimental variation', rolloutPercentage: 0.25, variables: null },
            { key: 'on', name: 'On', rolloutPercentage: 0.25, variables: null },
            { key: 'off', name: 'Off', rolloutPercentage: 0.5, variables: null },
        ],
        url: '',
    },
    {
        id: 'first_product_page',
        name: 'First product page',
        createdAt: '2022-10-28T18:52:17.592443Z',
        updatedAt: '2022-10-30T18:55:27.996195Z',
        enabledAt: null,
        minimumVersion: '1.1.0',
        status: 'archived',
        isNewlyEnabledInThisVersion: false,
        isNewlyDisabledInThisVersion: false,
        isSpecificallyTargetingThisVersion: false,
        isSpecificallyNotTargetingThisVersion: false,
        didChangeInThisVersion: false,
        shouldHighlight: false,
        highlightTooltipText: '',
        isStale: false,
        staleTooltipText: '',
        isEstimatedEnabledAt: false,
        isReadOnly: false,
        rules: [
            {
                id: 'd78f171a-4cfe-4f42-810f-9699d4e16e47',
                name: 'Admin or Beta',
                isDefault: false,
                audienceConditions: null,
                conditions: [
                    {
                        attribute: 'role',
                        negate: false,
                        predicate: 'matches',
                        values: ['admin', 'beta'],
                    },
                ],
                variations: [
                    {
                        key: 'on',
                        name: 'On',
                        weight: 100,
                    },
                ],
            },
            {
                id: 'd78f171a-4cfe-4f42-810f-9699d4e16e47',
                name: 'Version > 1.0.0',
                isDefault: false,
                audienceConditions: null,
                conditions: [
                    {
                        attribute: 'appVersion',
                        negate: false,
                        predicate: 'greaterThan',
                        values: ['1.1.0'],
                    },
                ],
                variations: [
                    {
                        key: 'on',
                        name: 'On',
                        weight: 100,
                    },
                ],
            },
        ],
        owner: null,
        variations: [
            { key: 'special', name: 'Special experimental variation', variables: null, rolloutPercentage: 0 },
            { key: 'on', name: 'On', variables: null, rolloutPercentage: 0 },
            { key: 'off', name: 'Off', variables: null, rolloutPercentage: 0 },
        ],
        url: '',
    },
    {
        id: 'dark_red_logo',
        name: 'Dark red logo',
        createdAt: '2022-11-01T00:15:52.133933Z',
        updatedAt: '2022-11-02T01:22:24.597475Z',
        enabledAt: null,
        minimumVersion: '1.1.0',
        rolloutPercentage: 0,
        status: 'disabled',
        isNewlyEnabledInThisVersion: false,
        isNewlyDisabledInThisVersion: false,
        isSpecificallyTargetingThisVersion: false,
        isSpecificallyNotTargetingThisVersion: false,
        didChangeInThisVersion: false,
        shouldHighlight: false,
        highlightTooltipText: '',
        isStale: false,
        staleTooltipText: '',
        isEstimatedEnabledAt: false,
        isReadOnly: false,
        rules: [
            {
                id: 'd78f171a-4cfe-4f42-810f-9699d4e16e47',
                name: 'Version > 1.0.0',
                isDefault: false,
                audienceConditions: null,
                conditions: [
                    {
                        attribute: 'appVersion',
                        negate: false,
                        predicate: 'greaterThan',
                        values: ['1.1.0'],
                    },
                ],
                variations: [
                    {
                        key: 'on',
                        name: 'On',
                        weight: 100,
                    },
                ],
            },
        ],
        owner: null,
        variations: [
            { key: 'on', name: 'On', variables: [], rolloutPercentage: 0 },
            { key: 'off', name: 'Off', variables: [], rolloutPercentage: 0 },
        ],
        url: '',
    },
    {
        id: 'sharing_feature',
        name: 'Sharing feature',
        createdAt: '2022-10-14T16:15:59.697382Z',
        updatedAt: '2022-11-09T11:39:28.078007Z',
        enabledAt: null,
        minimumVersion: '1.2.0',
        rolloutPercentage: 1,
        status: 'disabled',
        isNewlyEnabledInThisVersion: false,
        isNewlyDisabledInThisVersion: false,
        isSpecificallyTargetingThisVersion: false,
        isSpecificallyNotTargetingThisVersion: false,
        didChangeInThisVersion: false,
        shouldHighlight: false,
        highlightTooltipText: '',
        isStale: false,
        staleTooltipText: '',
        isEstimatedEnabledAt: false,
        isReadOnly: false,
        rules: [
            {
                id: 'd78f171a-4cfe-4f42-810f-9699d4e16e47',
                name: 'Serve to 1.2.0',
                isDefault: false,
                audienceConditions: null,
                conditions: [
                    {
                        attribute: 'appVersion',
                        negate: false,
                        predicate: 'matches',
                        values: ['1.2.0'],
                    },
                ],
                variations: [
                    {
                        key: 'on',
                        name: 'On',
                        weight: 100,
                    },
                ],
            },
        ],
        owner: null,
        variations: [
            { key: 'on', name: 'On', variables: [], rolloutPercentage: 0 },
            { key: 'off', name: 'Off', variables: [], rolloutPercentage: 0 },
        ],
        url: '',
    },
];
